import { EventEmitter } from '@angular/core';
var PaginationComponent = /** @class */ (function () {
    function PaginationComponent() {
        this.Arr = Array;
        this.pageChange = new EventEmitter();
        this.pageChangeUrl = new EventEmitter();
    }
    Object.defineProperty(PaginationComponent.prototype, "hidden", {
        get: function () {
            return !this.pagination || (this.hideWhenOnly && this.isTheOnlyPage());
        },
        enumerable: true,
        configurable: true
    });
    PaginationComponent.prototype.ngOnInit = function () {
        this.name = this.name || 'Lapozás';
        this.small = this.size === 'sm';
        this.large = this.size === 'lg';
    };
    PaginationComponent.prototype.isTheOnlyPage = function () {
        return this.pagination.last_page === 1;
    };
    PaginationComponent.prototype.jumpTo = function (url) {
        this.pageChangeUrl.emit(url);
        try {
            this.pageChange.emit(url.split('=').pop());
        }
        catch (error) {
            console.error(error);
        }
    };
    PaginationComponent.prototype.jumpToPage = function (page) {
        this.pageChange.emit(page);
        this.pageChangeUrl.emit(this.pagination.path + '?page=' + page);
    };
    return PaginationComponent;
}());
export { PaginationComponent };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/shared/components/pagination/pagination.component.ts.pre-build-optimizer.js